// extracted by mini-css-extract-plugin
export var accordion = "_b5-0";
export var chevron = "_b5-3";
export var closed = "_b5-2";
export var content = "_b5-4";
export var open = "_b5-1";
export var rotate = "_b5-5";